import React from 'react';
import { createTheme, ThemeProvider, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectDarkMode } from '@store/ThemeSlice';
import {
  adminDarkColors,
  darkColors,
  darkSemanticColors,
  createDarkModeOverrides,
} from '@theme/index';

/**
 * Admin theme wrapper that applies dark mode when enabled.
 * Inherits from parent theme and only overrides when dark mode is active.
 */
function AdminThemeWrapper({ children }: Readonly<{ children: React.ReactNode }>) {
  const parentTheme = useTheme();
  const darkMode = useSelector(selectDarkMode);

  const theme = React.useMemo(() => {
    if (darkMode) {
      return createTheme({
        ...parentTheme,
        palette: {
          mode: 'dark',
          primary: adminDarkColors.primary,
          secondary: adminDarkColors.secondary,
          background: darkColors.background,
          text: darkColors.text,
          divider: darkColors.divider,
          action: darkColors.action,
          ...darkSemanticColors,
        },
        components: {
          ...parentTheme.components,
          ...createDarkModeOverrides(adminDarkColors.primary.main),
        },
      });
    }

    return parentTheme;
  }, [darkMode, parentTheme]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default AdminThemeWrapper;
